import { FC, useEffect } from 'react';
import { Drawer } from '~/shared/components/Drawer';
import { useScrollLock } from '~/shared/hooks';

import Close from '~/icons/close.svg';
import Button from '../components/Button';
import Typography from '../components/Typography/Typography';
import Flex from '../components/Flex';
import styles from './InfoDrawer.module.scss';

type InfoDrawerProps = {
    children: React.ReactNode;
    title?: string;
    open: boolean;
    ctaTitle?: string;
    close: () => void;
    onCtaClick?: (value?: boolean) => void;
};

export const InfoDrawer: FC<InfoDrawerProps> = ({
    children,
    title,
    open,
    ctaTitle,
    close,
    onCtaClick,
}) => {
    const { lock, unlock } = useScrollLock();

    useEffect(() => {
        if (open) {
            lock();
        }
        return () => unlock();
    }, [lock, unlock, open]);

    return (
        <Drawer open={open} onClose={close} isInfo ariaTitle={title}>
            <div className={styles.content}>
                <div className={styles.headerWrapper}>
                    <Flex justifyContent="space-between" alignItems="center">
                        <Typography as="h2" variant="paragraph-XL">
                            {title}
                        </Typography>
                        <Button
                            aria-label="Close"
                            className={styles.closeButton}
                            variant="plain"
                            onClick={close}
                        >
                            <Close className={styles.closeIcon} />
                        </Button>
                    </Flex>
                </div>

                <div className={styles.container}>{children}</div>
                <div className={styles.footer}>
                    {onCtaClick && ctaTitle && (
                        <Button
                            className={styles.ctaButton}
                            variant="primary"
                            onClick={() => onCtaClick(true)}
                        >
                            {ctaTitle}
                        </Button>
                    )}
                </div>
            </div>
        </Drawer>
    );
};
export default InfoDrawer;
